<div class="custom-button-container-right">
  <input type="text"
         [value]="value || ''"
         [readonly]="readonly"
         [disabled]="disabled"
         [placeholder]="this.placeholder()"
         (change)="onChange($event)">
  <yo-button *ngIf="copy"
             [theme]="ButtonThemeEnum.SECONDARY_INNER"
             iconClass="fas fa-copy"
             size="small"
             title="Copier dans le presse-papier"
             (onClick)="copyToClipBoard()"
  >
  </yo-button>
</div>
